<template>
  <aside class="estimate-recommend">
    <h3 class="estimate-recommend__title"><span>おすすめ洋用品</span><small>RECOMMEND ITEM</small></h3>
    <div class="estimate-recommend__slider" :class="{'no-swiper': recommend.length <= 4}">
      <ul
        class="swiper-wrapper estimate-recommend__slider-wrapper"
      >
        <li
          v-for="(item, i) in recommend"
          :key="`estimate-recommend__item${i}`"
          class="swiper-slide estimate-recommend__item"
        >
          <div v-if="item.url" >
            <a :href="item.url" target="_blank">
              <figure class="estimate-recommend__item-img"><img :src="item.image_url" :alt="item.item_name"></figure>
              <p
                class="estimate-recommend__item-title"
                v-text="item.item_name"
              />
            </a>
            <p
              v-if="item.price"
              class="estimate-recommend__item-price"
              v-html="`${item.price.toLocaleString()}円<small>(税込)</small>${item.price_more ? '〜' : ''}`"
            />
          </div>
          <div v-else>
            <figure class="estimate-recommend__item-img"><img :src="item.image_url" :alt="item.item_name"></figure>
            <p
              class="estimate-recommend__item-title"
              v-text="item.item_name"
            />
            <p
              v-if="item.price"
              class="estimate-recommend__item-price"
              v-html="`${item.price.toLocaleString()}円<small>(税込)</small>${item.price_more ? '〜' : ''}`"
            />
          </div>
        </li>
      </ul>

      <button class="swiper-button-prev estimate-recommend__prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
          <g transform="translate(-150 -2722)">
            <rect data-name="長方形 2503" width="48" height="48" transform="translate(150 2722)"/>
            <path d="M1.635,13.876,0,12.24,5.289,6.932,0,1.637,1.635,0,8.559,6.932,1.635,13.876Z" transform="translate(178.28 2752.938) rotate(180)" fill="#fff"/>
          </g>
        </svg>
      </button>

      <button class="swiper-button-next estimate-recommend__next">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
          <g transform="translate(-150 -2722)">
            <rect data-name="長方形 2503" width="48" height="48" transform="translate(150 2722)"/>
            <path d="M1.635,13.876,0,12.24,5.289,6.932,0,1.637,1.635,0,8.559,6.932,1.635,13.876Z" transform="translate(178.28 2752.938) rotate(180)" fill="#fff"/>
          </g>
        </svg>
      </button>
    </div>

    <p class="estimate-recommend__more"><a href="https://honda-dream-japan.co.jp/wear-gear/
" target="_blank" class="button">洋用品をもっと見る</a></p>
  </aside>
</template>

<script>
import {defineComponent, computed} from 'vue'
import Swiper from 'swiper/bundle'
import {Util} from '../master.js'

export default defineComponent({
  name: 'EstimateRecommendList',
  components: {
  },
  props: {
    recommend: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  setup(props, context) {
    const recentlyProductSlider = null
    return {
      recentlyProductSlider
    }
  },
  mounted() {
    window.addEventListener('resize', this.initializeSwiper)

    setTimeout(this.initializeSwiper, 500)
  },
  unmounted() {
    window.removeEventListener('resize', this.initializeSwiper, true)
  },
  methods: {
    initializeSwiper () {
      if (this.recommend.length <= 4) {
        document.querySelector('.estimate-recommend__slider').classList.add('no-swiper')
        return
      }

      const isMobile = window.matchMedia('(max-width: 767px)').matches
      const swiperContainer = document.querySelector('.estimate-recommend__slider')

      if (!isMobile && this.recentlyProductSlider == null) {
        this.recentlyProductSlider = new Swiper(swiperContainer, {
          slidesPerView: 2,
          spaceBetween: 20,
          autoplay: {
            delay: 3000,
          },
          speed: 1000,
          loop: true,
          navigation: {
            nextEl: '.estimate-recommend__next',
            prevEl: '.estimate-recommend__prev',
          },
          breakpoints: {
            900: {
              slidesPerView: 3,
            },
            1100: {
              slidesPerView: 4,
            },
          }
        })
      } else if (isMobile && this.recentlyProductSlider) {
        this.recentlyProductSlider.destroy()
        this.recentlyProductSlider = null
      }
    }
  }
})

</script>